import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  Output,
} from '@angular/core';
import {
  AppState,
  CategoryFilterOption,
  FilterOption,
  MainCategoryFilterState,
} from '@immosky/types';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import {
  CATEGORY_DEFAULT_OPTION,
  categoryFilterOptions,
  isCategoryFilterActive,
  selectContractTypeFilterState,
  selectMainCategoryFilter,
} from '@immosky/object-search-filter';
import { map, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'lib-category-filter',
  templateUrl: './category-filter.component.html',
  styleUrls: ['./category-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryFilterComponent implements OnDestroy {
  private categorySubscription!: Subscription;
  private contactTypeSubscription: Subscription;

  @Output()
  update = new EventEmitter<CategoryFilterOption>();

  categoryOptions: CategoryFilterOption[] = categoryFilterOptions.allOptions;
  currentCategoryOption: CategoryFilterOption = CATEGORY_DEFAULT_OPTION;
  filterState!: MainCategoryFilterState;

  get canReset(): boolean {
    return isCategoryFilterActive(
      this.currentCategoryOption,
      this.filterState.default
    );
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    this.contactTypeSubscription = this.store
      .pipe(
        select(selectContractTypeFilterState),
        map((contact_type_state) => contact_type_state.filter.value),
        distinctUntilChanged()
      )
      .subscribe((contract_type) => {
        switch (contract_type) {
          case 'buy':
            this.categoryOptions = categoryFilterOptions.buyOptions;
            break;
          case 'rent':
            this.categoryOptions = categoryFilterOptions.rentOptions;
            break;
        }
        this.cdRef.markForCheck();
      });
    this.categorySubscription = this.store
      .pipe(select(selectMainCategoryFilter))
      .subscribe((filter: MainCategoryFilterState) => {
        this.filterState = filter;
        this.currentCategoryOption = filter.filter;
        this.cdRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.categorySubscription.unsubscribe();
    this.contactTypeSubscription.unsubscribe();
  }

  onChange(option: FilterOption) {
    this.setCategoryFilter(option as CategoryFilterOption);
  }

  resetCategory() {
    this.setCategoryFilter(CATEGORY_DEFAULT_OPTION);
  }

  private setCategoryFilter(filter: CategoryFilterOption) {
    this.currentCategoryOption = filter;
    this.update.emit(filter);
  }
}
